import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const intel = articles.slice(2, 7);

export default function IntelSection() {
  return (
    <section id="intel" className="w-full bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          kicker="INTEL"
          title="瓜田情报"
          desc="把散落的碎片信息按线索归拢，标注来源与核实状态，帮你看清事件的来龙去脉。"
          action={{ label: "进入情报站", to: "/live?tab=intel" }}
        />
        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="flex flex-col gap-3 lg:col-span-2">
            {intel.map((article, index) => (
              <ArticleCard
                key={article.id}
                article={article}
                variant="horizontal"
                rank={index + 1}
              />
            ))}
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-black text-foreground-950">
                <i className="ri-shield-check-line text-accent-700" />
                情报核实说明
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                每条情报都会标注状态：已核实、待核实、已更正。对于暂无第二信源的说法，我们只呈现线索，不下结论。
              </p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-black text-foreground-950">情报分级</h3>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-center gap-2 text-foreground-700">
                  <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[11px] text-primary-700">
                    已核实
                  </span>
                  有公开信源或现场画面佐证
                </li>
                <li className="flex items-center gap-2 text-foreground-700">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                    待核实
                  </span>
                  仅单一信源，持续跟进
                </li>
                <li className="flex items-center gap-2 text-foreground-700">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                    已更正
                  </span>
                  与后续信息不符，已修订
                </li>
              </ul>
              <Link
                to="/about"
                className="mt-5 inline-flex cursor-pointer items-center gap-1.5 text-sm text-primary-700 transition-colors hover:text-primary-600"
              >
                了解我们的内容原则
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}